import {CYCLING, HORSES, MARBLES} from '../../../../../constants/identifiers';

export function hasEventTypeRacerNumberUI(eventType) {
    switch (eventType) {
        case HORSES:
        case CYCLING:
        case MARBLES:
            return true;
        default:
            return false;
    }
}

export function sortTrifectaRacers(racers1, racers2) {
    let r1 = '' + racers1.first + racers1.second + racers1.third;
    let r2 = '' + racers2.first + racers2.second + racers2.third;
    return Number(r1) - Number(r2);
}

export function sortRacersByOddsFirst(r1, r2) {
    return Number(r1.oddsFirst) - Number(r2.oddsFirst);
}

export function sortRacersByOdd(betPossibilitie1, betPossibilitie2) {
    return Number(betPossibilitie1.odd) - Number(betPossibilitie2.odd);
}

export function sortExactaRacers(racers1, racers2) {
    let r1 = '' + racers1.first + racers1.second;
    let r2 = '' + racers2.first + racers2.second;
    return Number(r1) - Number(r2);
}


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/racing/helpers/racersHelper.js